import { FORM_FIELD_ACSS_BALLOT, FORM_FIELD_ACSS_BALLOT_NUMBER, FORM_FIELD_AGREEMENT_1, FORM_FIELD_AGREEMENT_2, FORM_FIELD_AGREEMENT_3, FORM_FIELD_AGREEMENT_4, FORM_FIELD_ANIMAL_HEALTH, FORM_FIELD_BALLOT_COUNTRY, FORM_FIELD_BALLOT_COUNTRY_EUEFTA, FORM_FIELD_COMPLEX_SCENARIOS, FORM_FIELD_CPE_BALLOT, FORM_FIELD_CPE_BALLOT_ENTITY, FORM_FIELD_CPE_BALLOT_NUMBER, FORM_FIELD_CPE_ENTITY, FORM_FIELD_HEART_HEALTH, FORM_FIELD_INTEGUMENTAL_HEALTH, FORM_FIELD_MENTAL_HEALTH, FORM_FIELD_MUSCLE_HEALTH, FORM_FIELD_NEURO_HEALTH, FORM_FIELD_OCCUPATION_HEALTH, FORM_FIELD_ONCOLOGICAL_HEALTH, FORM_FIELD_OTHER_CONDITIONS, FORM_FIELD_PREVIOUS_REGISTRATION, FORM_FIELD_PROMOTION_PROTECTION_HEALTH, FORM_FIELD_RESPIRATORY_HEALTH, FORM_FIELD_WELL_BEING_HEALTH, FORM_FIELD_WOMEN_HEALTH, FORM_STEP_10_STATE, FORM_STEP_11_STATE, FORM_STEP_1_STATE, FORM_STEP_2_STATE, FORM_STEP_3_STATE, FORM_STEP_4_STATE, FORM_STEP_5_STATE, FORM_STEP_6_STATE, FORM_STEP_7_STATE, FORM_STEP_8_STATE, FORM_STEP_9_STATE, STEP_STATE_NOT_SUBMITTED } from "../../common/constants";
import { formatYesNoDropdownLists } from "../../common/utils/form-data-utils";
import { UPDATE_FORM_STEP, UPDATE_STEP_10_STATE, UPDATE_STEP_11_STATE, UPDATE_STEP_1_STATE, UPDATE_STEP_2_STATE, UPDATE_STEP_3_STATE, UPDATE_STEP_4_STATE, UPDATE_STEP_5_STATE, UPDATE_STEP_6_STATE, UPDATE_STEP_7_STATE, UPDATE_STEP_8_STATE, UPDATE_STEP_9_STATE } from "../action-types/form";

const initialState = {
    basketProducts: [],
    formFields: [
        // STEP 1
        { key: FORM_FIELD_AGREEMENT_1, value: false },
        { key: FORM_FIELD_AGREEMENT_2, value: false },
        { key: FORM_FIELD_AGREEMENT_3, value: false },
        { key: FORM_FIELD_AGREEMENT_4, value: false },
        { key: FORM_STEP_1_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 2
        { key: FORM_STEP_2_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 3
        { key: FORM_FIELD_PREVIOUS_REGISTRATION, value: formatYesNoDropdownLists(false, "pt") },
        { key: FORM_FIELD_ACSS_BALLOT, value: formatYesNoDropdownLists(false, "pt") },
        { key: FORM_FIELD_BALLOT_COUNTRY_EUEFTA, value: formatYesNoDropdownLists(false, "pt") },
        { key: FORM_FIELD_CPE_BALLOT, value: formatYesNoDropdownLists(false, "pt") },
        { key: FORM_FIELD_ACSS_BALLOT_NUMBER, value: "" },
        { key: FORM_FIELD_CPE_ENTITY, value: "" },
        { key: FORM_FIELD_CPE_BALLOT_NUMBER, value: "" },
        { key: FORM_FIELD_BALLOT_COUNTRY, value: "" },
        { key: FORM_FIELD_CPE_BALLOT_ENTITY, value: "" },
        { key: FORM_STEP_3_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 4
        { key: FORM_STEP_4_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 5
        { key: FORM_STEP_5_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 6
        { key: FORM_STEP_6_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 7
        { key: FORM_FIELD_MENTAL_HEALTH, value: null },
        { key: FORM_FIELD_OCCUPATION_HEALTH, value: null },
        { key: FORM_FIELD_WOMEN_HEALTH, value: null },
        { key: FORM_FIELD_WELL_BEING_HEALTH, value: null },
        { key: FORM_FIELD_PROMOTION_PROTECTION_HEALTH, value: null },
        { key: FORM_FIELD_MUSCLE_HEALTH, value: null },
        { key: FORM_FIELD_NEURO_HEALTH, value: null },
        { key: FORM_FIELD_HEART_HEALTH, value: null },
        { key: FORM_FIELD_RESPIRATORY_HEALTH, value: null },
        { key: FORM_FIELD_INTEGUMENTAL_HEALTH, value: null },
        { key: FORM_FIELD_ONCOLOGICAL_HEALTH, value: null },
        { key: FORM_FIELD_ANIMAL_HEALTH, value: null },
        { key: FORM_FIELD_COMPLEX_SCENARIOS, value: null },
        { key: FORM_FIELD_OTHER_CONDITIONS, value: null },
        { key: FORM_STEP_7_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 8
        { key: FORM_STEP_8_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 9
        { key: FORM_STEP_9_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 10
        { key: FORM_STEP_10_STATE, value: STEP_STATE_NOT_SUBMITTED },
        // STEP 11
        { key: FORM_STEP_11_STATE, value: STEP_STATE_NOT_SUBMITTED }
    ],
    step1State: STEP_STATE_NOT_SUBMITTED,
    step2State: STEP_STATE_NOT_SUBMITTED,
    step3State: STEP_STATE_NOT_SUBMITTED,
    step4State: STEP_STATE_NOT_SUBMITTED,
    step5State: STEP_STATE_NOT_SUBMITTED,
    step6State: STEP_STATE_NOT_SUBMITTED,
    step7State: STEP_STATE_NOT_SUBMITTED,
    step8State: STEP_STATE_NOT_SUBMITTED,
    step9State: STEP_STATE_NOT_SUBMITTED,
    step10State: STEP_STATE_NOT_SUBMITTED,
    step11State: STEP_STATE_NOT_SUBMITTED
};

const registrationFormReducer = (state = initialState, action) => {
    switch(action.type) {
        case UPDATE_FORM_STEP:
            return {
                ...state,
                formFields: action.formFields
            };
        case UPDATE_STEP_1_STATE:
            return {
                ...state,
                step1State: action.step1State
            };
        case UPDATE_STEP_2_STATE:
            return {
                ...state,
                step2State: action.step2State
            };
        case UPDATE_STEP_3_STATE:
            return {
                ...state,
                step3State: action.step3State
            };
        case UPDATE_STEP_4_STATE:
            return {
                ...state,
                step4State: action.step4State
            };
        case UPDATE_STEP_5_STATE:
            return {
                ...state,
                step5State: action.step5State
            };
        case UPDATE_STEP_6_STATE:
            return {
                ...state,
                step6State: action.step6State
            };
        case UPDATE_STEP_7_STATE:
            return {
                ...state,
                step7State: action.step7State
            };
        case UPDATE_STEP_8_STATE:
            return {
                ...state,
                step8State: action.step8State
            };
        case UPDATE_STEP_9_STATE:
            return {
                ...state,
                step9State: action.step9State
            };
        case UPDATE_STEP_10_STATE:
            return {
                ...state,
                step10State: action.step10State
            };
        case UPDATE_STEP_11_STATE:
            return {
                ...state,
                step11State: action.step11State
            };
        default:
            return state;
    }
}

export default registrationFormReducer;